import { useEffect } from 'react';

/**
 * formats a link to be shared via deep link to facebook messenger
 * @param {string} link
 * @returns {Object} An oject containing mapping to deeplink to certain platforms
 */
export const deepLinks = ({ link, message = '', subject = '' }) => {
	const encodedQuery = encodeURIComponent(link);
	const fullEncodedQuery = encodeURIComponent(`${link}\n${message}`);
	const encodedSubject = encodeURIComponent(subject);

	return {
		messenger: makeOnClick(
			`fb-messenger://share/?link=${encodedQuery}&app_id=${process.env.FB_APP_ID}`
		),
		sms: makeOnClick(`sms://${isAppleUA ? '&' : '?'}body=${fullEncodedQuery}`),
		defaultEmailClient: makeOnClick(
			`mailto:?body=${fullEncodedQuery}&subject=${encodedSubject}`
		),
	};
};

const isAppleUA = () =>
	navigator.userAgent.match(/Macintosh/i) ||
	navigator.userAgent.match(/iPad/i) ||
	navigator.userAgent.match(/iPhone/i) ||
	navigator.userAgent.match(/iPod/i);

const makeOnClick = (data) => (e) => {
	window.open(data, '_top');
};
